/** 会员类型（QUOTA.固定提额 SPEED.加速） */
export enum packageTypeEnum {
  /** 桔多多-提额权益 */
  QUOTA = 'QUOTA',
  /** 加速 提速 */
  SPEED = 'SPEED',
  /** 自营B */
  CHANNEL_B = 'CHANNEL_B',
  /** 普通权益-金融VIP */
  NORMAL = 'NORMAL',
  /** 臻还卡 */
  REPAYMENT_CARD = 'REPAYMENT_CARD'
}

/** 当前权益兑换状态 */
export enum exchangeStatusEnum {
  /** 待发放 */
  WAITING_GRANT = 'WAITING_GRANT',
  /** 已发放 */
  GRANTED = 'GRANTED',
  /** 待兑换 */
  WAITING_EXCHANGE = 'WAITING_EXCHANGE'
}


/** 会员兑换入口分类 */
export enum packageEntranceEnum {
  /** 自营B-臻享卡 兑换入口 */
  CHANNEL_B = 1,
  /** 臻系列卡兑换入口 */
  ZHEN_SERIES_CARD = 2,
  /**
   * 卖量-臻享卡
   */
  SELL_FLOW_ZXK = 4,
  /** 渠道权益 兑换入口 */
  CHANNEL_ELSE = 6,
}
